<script lang="ts">
  let { title = "", description = "", children } = $props();
</script>

<div class="rounded-xl border border-base-200 bg-base-100 text-base-content shadow-sm flex flex-col overflow-hidden">
  {#if title || description}
    <div class="flex flex-col space-y-1 p-6 pb-2">
      <h3 class="font-semibold leading-none tracking-tight">{title}</h3>
      {#if description}
        <p class="text-[13px] text-base-content/60 mt-1 leading-snug">{description}</p>
      {/if}
    </div>
  {/if}
  <div class="p-6 pt-3 flex-1 flex flex-col">
    {#if children}
      {@render children()}
    {/if}
  </div>
</div>
